module.exports = "<div class=\"header shadow rounded\">\n    <div class=\"header-title\">\n        <!-- <h4>CRM</h4> -->\n        <h4> Sales Information Management (CRM) </h4>\n    </div>\n    <span class=\"clearfix\"></span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/header/header.component.html
// module id = ./src/app/common/header/header.component.html
// module chunks = main